/* tslint:disable: no-use-before-declare */
import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormInputDateComponent),
  multi: true,
};

@Component({
  selector: 'app-form-input-date',
  templateUrl: './form-input-date.component.html',
  styleUrls: ['./form-input-date.component.sass'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class FormInputDateComponent implements OnInit, ControlValueAccessor {
  errors: any;
  private _displayValue: Date;
  @ViewChild('pickerDesde') picker;
  @Input() messageError: string;
  @Input() width: string;
  @Input() label: string;
  @Input() max: Date;
  @Input() disabled = false;
  @Input() hasError = true;
  @Input() get displayValue(): Date {
    return this._displayValue;
  }
  set displayValue(display: Date) {
    this._displayValue = display;
    if (
      this._displayValue instanceof Date &&
      !isNaN(this._displayValue.getTime())
    ) {
      this.input.nativeElement.value = moment(this._displayValue).format(
        'DD-MM-YYYY'
      );
    } else if (this._displayValue) {
      // if truthy
      this.input.nativeElement.value = 'Fecha inválida';
    } else {
      this.input.nativeElement.value = '';
    }
  }
  @ViewChild('input') input: ElementRef;

  @Output() $onChange: EventEmitter<any> = new EventEmitter();

  innerValue: any = '';

  constructor() {}

  ngOnInit() {
    if (this.displayValue) {
      this.input.nativeElement.value = moment(this.displayValue).format(
        'DD-MM-YYYY'
      );
    }
  }

  onChange(e: any) {
    // this.innerValue = e.value;
    const v = e.targetElement.value;
    this.value = v;
    this.propagateChange(this.innerValue);
    // this.$onChange.emit();
  }

  get value(): any {
    return this.innerValue;
  }

  set value(v: any) {
    if (v !== this.innerValue) {
      if (moment.isMoment(v)) {
        this.innerValue = v.toDate();
      } else if (v instanceof Date) {
        this.innerValue = v;
      } else {
        if (v) {
          // if truthy
          const thisMoment = moment(v, 'DD-MM-YYYY');
          this.innerValue = thisMoment.toDate();
        } else {
          this.innerValue = v;
        }
      }
      if (
        this.innerValue instanceof Date &&
        !isNaN(this.innerValue.getTime())
      ) {
        this.input.nativeElement.value = moment(this.innerValue).format(
          'DD-MM-YYYY'
        );
      } else if (this.innerValue) {
        // if truthy
        this.input.nativeElement.value = 'Fecha inválida';
      } else {
        this.input.nativeElement.value = '';
      }
    }
  }

  propagateChange = (_: any) => {};

  writeValue(value: any) {
    this.value = value;
  }

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any) {}

  open() {
    this.picker.open();
  }
}
